module.exports = __webpack_public_path__ + "media/images/project/tags-b4275490f5b16dc18276eab239c63fcf.svg";